import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const TAGLINES = [
  { line: "Your profile isn't sh*t.",                            tone: "white" },
  { line: "Your CGPA isn't sh*t.",                               tone: "ink" },
  { line: "The way you tell your story to universities — is.",  tone: "red" },
  { line: "Let's fix that sh*t.",                                tone: "highlight" },
];

export default function RealTalkSection() {
  return (
    <section className="relative bg-[#c92e34] text-white py-16 md:py-24 border-b-[3px] border-[#282829] overflow-hidden" data-testid="tagline-section">
      <div
        className="absolute inset-0 opacity-15 pointer-events-none"
        style={{ backgroundImage: "radial-gradient(#fff 1.2px, transparent 1.2px)", backgroundSize: "22px 22px" }}
      />
      <div className="relative max-w-5xl mx-auto px-6 sm:px-10 text-center">
        <span className="inline-block bg-white text-[#c92e34] text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full border-2 border-[#282829] -rotate-2">
          Real talk
        </span>
        <div className="mt-8 space-y-3 md:space-y-4">
          {TAGLINES.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30, rotate: i % 2 ? 1.5 : -1.5 }}
              whileInView={{ opacity: 1, y: 0, rotate: i % 2 ? 1.5 : -1.5 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ delay: i * 0.12, type: "spring", stiffness: 90 }}
              className={`inline-block px-5 md:px-8 py-3 md:py-5 rounded-full border-2 ${
                t.tone === "white"
                  ? "bg-white text-[#282829] border-[#282829] brutal-shadow-ink"
                  : t.tone === "ink"
                    ? "bg-[#282829] text-white border-white brutal-shadow-red-sm"
                    : t.tone === "red"
                      ? "bg-[#c92e34] text-white border-white"
                      : "bg-[#282829] text-white border-[#c92e34]"
              }`}
              data-testid={`tagline-pill-${i}`}
            >
              <span className="font-display text-2xl sm:text-3xl md:text-5xl leading-none tracking-tight">
                {t.line}
              </span>
            </motion.div>
          ))}
        </div>
        <a
          href="#inquiry"
          className="mt-12 inline-flex items-center gap-2 bg-[#282829] hover:bg-white hover:text-[#282829] text-white font-bold px-7 py-4 rounded-full border-2 border-white brutal-shadow-ink transition-colors"
          data-testid="tagline-cta"
        >
          Fix my sh*t <ArrowRight size={16} />
        </a>
      </div>
    </section>
  );
}
